import { IconProps } from "interfaces/icons";
import calculateSideByRatio from "utils/calculateSideByRatio";

const SIDES_RATIO = 0.923;

const TrashIcon = ({ size, color }: IconProps): JSX.Element => {
	let height = 26;
	if (size) {
		height = size;
	}

	const width = calculateSideByRatio(height, SIDES_RATIO);

	return (
		<svg
			width={width}
			height={height}
			viewBox="0 0 16 21"
			version="1.1"
			xmlns="http://www.w3.org/2000/svg"
		>
			<g
				id="Rev-4"
				stroke="none"
				strokeWidth="1"
				fill="none"
				fillRule="evenodd"
			>
				<g
					id="Nova-Enterprise---Home-Page-v2--Selected"
					transform="translate(-1192.000000, -329.000000)"
					fill={color || "#8E9BBC"}
					fillRule="nonzero"
				>
					<g id="Bulk-Actions" transform="translate(1107.000000, 329.000000)">
						<path
							d="M92.6521739,16.722408 C92.6521739,17.0918293 92.963628,17.3913043 93.3478261,17.3913043 C93.7320242,17.3913043 94.0434783,17.0918293 94.0434783,16.722408 L94.0434783,7.62541806 C94.0434783,7.25599682 93.7320242,6.95652174 93.3478261,6.95652174 C92.963628,6.95652174 92.6521739,7.25599682 92.6521739,7.62541806 L92.6521739,16.722408 Z M97.9153443,18.745026 C97.9116391,18.8364925 97.8250394,18.9217412 97.7326924,18.9217412 L88.2673076,18.9217412 C88.1767541,18.9217412 88.0882848,18.8346153 88.0846557,18.745026 L87.5885626,6.49860086 C87.5667925,5.96119038 87.1255892,5.54368551 86.6031073,5.56607761 C86.0806255,5.58846971 85.6747184,6.04227936 85.6964885,6.57968983 L86.1925816,18.826115 C86.2385059,19.9597916 87.162307,20.8695652 88.2673076,20.8695652 L97.7326924,20.8695652 C98.8393103,20.8695652 99.7614107,19.9618508 99.8074184,18.826115 L100.303512,6.57968983 C100.325282,6.04227936 99.9193745,5.58846971 99.3968927,5.56607761 C98.8744108,5.54368551 98.4332075,5.96119038 98.4114374,6.49860086 L97.9153443,18.745026 Z M89.406051,16.7420679 C89.4154634,17.1113291 89.6825248,17.4018701 90.0025492,17.3910095 C90.3225736,17.3801489 90.5743744,17.0719993 90.5649619,16.7027382 L90.3330795,7.60575814 C90.323667,7.23649698 90.0566056,6.94595595 89.7365812,6.95681657 C89.4165568,6.96767718 89.1647561,7.27582679 89.1741686,7.64508792 L89.406051,16.7420679 Z M95.4350381,16.7027382 C95.4256256,17.0719993 95.6774264,17.3801489 95.9974508,17.3910095 C96.3174752,17.4018701 96.5845366,17.1113291 96.593949,16.7420679 L96.8258314,7.64508792 C96.8352439,7.27582679 96.5834432,6.96767718 96.2634188,6.95681657 C95.9433944,6.94595595 95.676333,7.23649698 95.6669205,7.60575814 L95.4350381,16.7027382 Z M100.050847,2.92173913 C100.57505,2.92173913 101,3.35777486 101,3.89565217 C101,4.43352949 100.57505,4.86956522 100.050847,4.86956522 L85.9491525,4.86956522 C85.4249501,4.86956522 85,4.43352949 85,3.89565217 C85,3.35777486 85.4249501,2.92173913 85.9491525,2.92173913 L89.3775682,2.92173913 L89.6464527,1.81814336 C89.8974191,0.788089962 90.8798677,-2.30926389e-14 91.9142245,-2.30926389e-14 L94.0857755,-2.30926389e-14 C95.1202393,-2.30926389e-14 96.1024578,0.787584974 96.3535473,1.81814336 L96.6224318,2.92173913 L100.050847,2.92173913 Z M94.7391304,2.7826087 L94.5785685,2.33176688 C94.5369056,2.21478142 94.3038881,2.08695652 94.1336381,2.08695652 L91.8663619,2.08695652 C91.6963852,2.08695652 91.463005,2.21503243 91.4214315,2.33176688 L91.2608696,2.7826087 L94.7391304,2.7826087 L94.7391304,2.7826087 Z"
							id="Delete"
						/>
					</g>
				</g>
			</g>
		</svg>
	);
};

export default TrashIcon;
